module.exports = __webpack_public_path__ + "img/zonaauto.6958b6b0.png";